import { render, staticRenderFns } from "./RecruitInfo.vue?vue&type=template&id=6277a87a&"
import script from "./RecruitInfo.vue?vue&type=script&lang=js&"
export * from "./RecruitInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports